import { render, staticRenderFns } from "./sdetail.vue?vue&type=template&id=2ab17e7f&scoped=true&"
import script from "./sdetail.vue?vue&type=script&lang=js&"
export * from "./sdetail.vue?vue&type=script&lang=js&"
import style0 from "./sdetail.vue?vue&type=style&index=0&id=2ab17e7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab17e7f",
  null
  
)

export default component.exports